"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;
function createStyles(styles) {
  return styles;
}